import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconConversation = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M10.8375 14.25L9 16.875L7.1625 14.25H2.25C2.05108 14.25 1.86032 14.1709 1.71967 14.0303C1.57902 13.8897 1.5 13.6989 1.5 13.5V3C1.5 2.80108 1.57902 2.61032 1.71967 2.46967C1.86032 2.32902 2.05108 2.25 2.25 2.25H15.75C15.9489 2.25 16.1397 2.32902 16.2803 2.46967C16.4209 2.61032 16.5 2.80108 16.5 3V13.5C16.5 13.6989 16.4209 13.8897 16.2803 14.0303C16.1397 14.1709 15.9489 14.25 15.75 14.25H10.8375ZM10.0568 12.75H15V3.75H3V12.75H7.94325L9 14.259L10.0568 12.75Z",
		fill: "#5F6062"
	})]
});
const ForwardRef = forwardRef(SvgIconConversation);
export { ForwardRef as ReactComponent };
